window.Layouts =
  flashes: ($$, $this) ->
    class FlashesView extends Backbone.View
      initialize: ->
        if @$el.data('loadPlaidScript') && !window.Plaid?
          @$('.js-plaid-alert').removeClass('u-hidden')

    new FlashesView el: $this